import { Component, Input } from '@angular/core';
import { I3MaintenanceDueTask } from '../../../../../api/intelli360/models/i3-assets-maintenance-due.model';
import { ToroEnums } from '../../../../../common/enumerations/toro.enums';
import I3TaskType = ToroEnums.I3TaskType;

@Component({
    selector: 'toro-i3-maint-task-card',
    templateUrl: './i3-maint-task-card.component.html',
    styleUrls: ['./i3-maint-task-card.component.less']
})
export class I3MaintTaskCardComponent {

    private _task: I3MaintenanceDueTask;
    @Input() set task(value: I3MaintenanceDueTask) {
        this._task = value;
        this.setData();
    }

    get task() { return this._task; }

    protected taskType: string;
    protected icoColor: string;

    // =========================================================================================================================================================
    // Helper Methods
    // =========================================================================================================================================================

    private setData(): void {
        if (this.task == null) { return; }

        switch (this.task.taskTypeId) {
            case I3TaskType.Preventive:
                this.taskType =  'STRINGS.PREVENTIVE';
                this.icoColor = '#FF7E2B';
                break;
            case I3TaskType.General:
                this.taskType =  'STRINGS.GENERAL';
                this.icoColor = '#006DD7';
                break;
            case I3TaskType.Repair:
                this.taskType =  'STRINGS.REPAIR';
                this.icoColor = 'grey';
                break;
        }
    }

}
